import { createRouter, createWebHashHistory } from "vue-router";
import FaceGame from "@/views/face-game/index.vue";

const router = createRouter({
  history: createWebHashHistory(),
  routes: [
    {
      path: "/",
      redirect: "/face-game",
    },
    {
      path: "/face-game",
      name: "face-game",
      component: FaceGame,
    },
  ],
});

export default router;
